import { render, staticRenderFns } from "./DeveloperPortal.vue?vue&type=template&id=3ba4d364&scoped=true"
import script from "./DeveloperPortal.vue?vue&type=script&lang=js"
export * from "./DeveloperPortal.vue?vue&type=script&lang=js"
import style0 from "./DeveloperPortal.vue?vue&type=style&index=0&id=3ba4d364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4d364",
  null
  
)

export default component.exports